export const commandIn = {
    c: {
        n: [],
        e: [],
        m: 0,
        os: 0,
        s: 0,
        t: 0
    }
}